/* @ngInject */
function textAngularDecorator($provide) {
  $provide.decorator(
    'taOptions',
    [
      '$delegate',
      function setTaOptions(taOptions) {
        const options = taOptions;
        options.forceTextAngularSanitize = false;

        options.toolbar = [
            ['bold', 'italics', 'underline', 'redo', 'undo', 'clear'],
            ['p', 'ul', 'ol', 'pre', 'quote'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            ['wordcount', 'charcount'],
        ];
        return options;
      },
    ]
  );
}

export default textAngularDecorator;



// WEBPACK FOOTER //
// ./client/components/comment-section/textangular.decorator.js